import ApisServiceApp from '@api/ApisServiceApp'
import { INotification, INotificationPush } from '@interfaces/notificationInterfaces'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

// Tạo thông báo
export function createNotification(data: INotification) {
  try {
    return ApisServiceApp.post('/notification/notifications', data)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function getListMyNotification(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/notification/notifications/my-notifications', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function getListNotification(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/notification/notifications/my-notifications', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function getListOptionNotification(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/notification/notifications/my-notifications', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function updateNotification(id: string) {
  try {
    return ApisServiceApp.put('/common/' + id + '/read-notification')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// gưi thông báo
export function sendNotification(data: INotificationPush) {
  try {
    return ApisServiceApp.post('/notification/notifications/push-notification', data)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function deleteNotification(id: string) {
  try {
    return ApisServiceApp.delete('/notification/notifications/' + id)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


export function deleteMultiNotification(idArr: string[]) {
  try {
    return ApisServiceApp.delete('/notification/notifications/multi-delete', {
      data: idArr,
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function getDetailNotification(id: string) {
  try {
    return ApisServiceApp.get('/notification/notifications/' + id)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


